import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TemplatePortal } from '@angular/cdk/portal';
import { HttpErrorResponse } from '@angular/common/http';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import {
  combineLatestWith,
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  finalize,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { ENTER } from '@angular/cdk/keycodes';
import { MatLegacyMenu as MatMenu } from '@angular/material/legacy-menu';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import {
  MatLegacyAutocomplete as MatAutocomplete,
  MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
} from '@angular/material/legacy-autocomplete';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import cloneDeep from 'lodash-es/cloneDeep';
import assign from 'lodash-es/assign';
import moment from 'moment';

import { DurationType, Predecessor, Task, TaskList, TaskStatus, Todo, WorkflowState } from '../tasks.types';
import { SelectableFieldDef } from 'app/shared/components/column-selector/column-selector.types';
import { LegacyTasksTabService } from '../services/tasks.service';
import { FoldersTabService } from 'app/shared/modules/folders/folders.service';
import { User } from 'app/core/models';
import { AccountService, AuthService } from 'app/core/services';
import { Project, Property } from 'app/modules/projects/projects.types';
import { FileResource, FolderResource } from 'app/shared/modules/folders/folders.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { Account, Activity, FieldDef, ProjectStage } from 'app/core/models/account.types';
import { ContactsService } from 'app/modules/contacts/contacts.service';
import { LayoutService } from 'app/layout/layout.service';
import { fromEvent, noop, Observable, of, zip } from 'rxjs';
import { RelatedToType } from 'app/shared/enums';
import { AccountFoldersService } from 'app/modules/folders/folders.service';
import { ManageTaskDependenciesComponent } from '../manage-task-dependencies/manage-task-dependencies.component';
import {
  Actions,
  ofActionCompleted,
  ofActionDispatched,
  ofActionErrored,
  ofActionSuccessful,
  Select,
  Store,
} from '@ngxs/store';
import { Folders } from '../../folders/state/actions';
import { PropertiesService } from 'app/modules/properties/properties.service';
import { MatLegacySlideToggleChange as MatSlideToggleChange } from '@angular/material/legacy-slide-toggle';
import { TaskRole } from 'app/modules/settings/task-roles/task-roles.types';
import { ConfirmDialogComponent } from 'app/shared/components/widgets/dialog/confirm/confirm.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';
import { AccountState } from 'app/state/account/state';
import { FeatureFlag, Module, NewPermission, Permission } from 'app/core/enums';
import { Approval, ApprovalStatus } from '../../approvals/approvals.types';
import { NotifyStakeholdersModalComponent } from '../../approvals/notify-stakeholders-modal/notify-stakeholders-modal.component';
import { UserState } from 'app/state/user/state';
import { TaskStatusService } from '../../tasks/services/task-status.service';
import { TsSnackbarService } from 'tsui';
import { LinkTasksComponent } from '../link-tasks/link-tasks.component';
import { Contact } from 'app/modules/contacts/contacts.types';
import { TaskUtils } from '../tasks.utils';
import { TaskState } from '@tasks/state/state';
import { TaskActions } from '@tasks/state/actions';

interface TaskDetailsConfig {
  showAssignedTaskRole?: boolean;
  showAttachements?: boolean;
  showActivities?: boolean;
  showSubtasks?: boolean;
  redirectOnClose?: boolean;
}

@Component({
  selector: 'task-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  host: { class: 'task-details' },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegacyTaskDetailsComponent {
  taskList$: Observable<Task> = this.store.select(TaskState.getTaskView).pipe(filter((taskList) => !!taskList));
  @Input() config: TaskDetailsConfig;

  constructor(
    private _tasksService: LegacyTasksTabService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this._tasksService.drawerToggle = true;
  }

  closeDrawer(): void {
    this._tasksService.drawerToggle = false;
  }
}
